// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"8bcd47bb","115":"cf8ef8cb","140":"366d5642","545":"02e1e818","646":"04baf6ea","861":"c2d92dcb"}[chunkId] + ".chunk.js";
};